import axios from 'axios';
import { BASE_URL } from './constant';

export async function getOrCreateCustomerId() {
  let customerId = localStorage.getItem('customerId');

  if (customerId) {
    try {
      const res = await axios.post(`${BASE_URL}/api/check_customer_id/`, { customerId });
      if (res.data.valid) return customerId; // Use existing
      console.log('CustomerId invalid, creating new one.');
    } catch (err) {
      console.log('Check error:', err);
      return customerId; // fallback
    }
  }

  // Prevent multiple simultaneous creations
  const lock = localStorage.getItem('customerIdCreating');
  if (lock) {
    // Another instance is already creating; wait until done
    let waitCount = 0;
    while (localStorage.getItem('customerIdCreating') && waitCount < 50) {
      await new Promise(r => setTimeout(r, 100)); // wait 100ms
      waitCount++;
    }
    return localStorage.getItem('customerId'); // return created ID
  }

  try {
    localStorage.setItem('customerIdCreating', 'true');
    const createRes = await axios.post(`${BASE_URL}/api/create_anonymous_user/`);
    customerId = createRes.data.customerId;
    localStorage.setItem('customerId', customerId);
    localStorage.removeItem('customerIdCreating');
    return customerId;
  } catch (err) {
    console.log('Create error:', err);
    localStorage.removeItem('customerIdCreating');
    return null;
  }
}
